import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name: 'arrayToString' })
export class ArrayToStringPipe implements PipeTransform {
  transform(list: string[], separator = ' ') {
    if (!list?.length || !Array.isArray(list)) return ''
    return list.join(separator)
  }
}
